import { useMemo, useCallback } from "react";
import qs from "query-string";
import { useHistory, useLocation } from "react-router";

export const useQueryState = (key) => {
  const history = useHistory();
  const location = useLocation();
  const search = useMemo(() => qs.parse(location.search), [location.search]);
  const set = useCallback(
    (value) => {
      history.push({
        search: qs.stringify({
          ...search,
          [key]: value,
        }),
      });
    },
    [history, search, key]
  );

  return [search[key], set];
};

export default useQueryState;
